import xml2js from "xml2js";

export const parseXml = (xmlContent: string): unknown => {
    let json = {};
    xml2js.parseString(xmlContent, { explicitArray: false }, (err: Error, result: any) => {
        json = result;
    });
    return json;
};
